// Consent-gated tracker loader. Nothing loads until the visitor/user has affirmatively opted in.
const KEY = "ez_consent_v1";
const PIXEL_ID = "2752212648143193";
const GA_ID = process.env.REACT_APP_GA_ID;

export const getLocalConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
};

export const setLocalConsent = (state) => {
  localStorage.setItem(KEY, JSON.stringify({ ...state, at: new Date().toISOString() }));
  applyTrackers(state);
};

const loadGA = () => {
  if (!GA_ID || window.gtag) return;
  const s = document.createElement("script");
  s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
};

const loadPixel = () => {
  if (window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
};

export const applyTrackers = (state) => {
  if (!state || state.child) return;
  if (state.analytics) loadGA();
  if (state.advertising) loadPixel();
};

// Logged-in users: server-side consent_state is authoritative and overrides the anonymous banner choice.
export const syncFromUser = (user) => {
  if (!user) return;
  const cs = user.consent_state || {};
  const state = { analytics: !!cs.analytics, advertising: !!cs.advertising, child: user.age_status === "child", decided: true };
  localStorage.setItem(KEY, JSON.stringify({ ...state, at: new Date().toISOString() }));
  applyTrackers(state);
};

export const initConsent = () => applyTrackers(getLocalConsent());
